import styled from "styled-components";

export const Container = styled.form`
    width: 100%;
    border: 1.5px solid #7A05A7;
    border-radius: 5px;
    margin: 1.5rem 0;

    display: flex;
    align-items: center;

    input{
        border: none;
        height: 100%;
        padding: 0.7rem 0;
        border-radius: 5px;
        margin: 0 0.1rem;
        flex: auto;
    }   

    button{
        height: 100%;
        background: #7A05A7;
        padding: 0.4rem 0;
        min-width: 3rem;
        border-radius: 0.25rem;
        border: none;

        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0.1rem;

        @media (min-width: 960px){
            cursor: pointer;
        }

        svg{
            color: #FFF;
        }
    }
`